module.exports = __webpack_public_path__ + "img/union.21f9391d.jpg";